import { useAppDispatch, useAppSelector } from "../../store/hooks";
import useDataSelector from "../../hooks/useDataSelector";
import {
  triggerRefetch,
  setIsContingencyMode,
  setIsLockVisitsMode,
} from "../../store/ganttChart";
import { NeedHelpButton } from "../header/NeedHelpButton";
import { LockVisitsButton } from "../header/LockVisitsButton";
import SendToNexus from "./configurationAndHelpBar/SendToNexusButton";
import ZoomComponent from "./ZoomComponent";
import PondooPlanStatusBar from "../statusBar/PondooPlanStatusBar";
import ContingencyStatusBlock from "../contingencySettings/ContingencyStatusBlock";
import HoverBoxAnchor from "../UI/hoverBox/HoverBoxAnchor";
import StandardButton from "../UI/buttons/StandardButton";
import { ReactComponent as InfoIcon } from "../../assets/icons/Info.svg";
import labels from "../../utils/labels";


const GanttChartConfigBar = () => {
  const dispatch = useAppDispatch();
  const { dataToUse, idScenario } = useDataSelector();
  const { selectedGanttChartTab, isLockVisitsMode, hasLockVisitsChanged } =
    useAppSelector((state) => state.ganttChartSlice);
  const { isLockRoutesMode } = useAppSelector((state) => state.lockRoutesSlice);

  return (
    <div
      style={{ height: "60px", padding: "0 var(--padding-lg)" }}
      className="w-full flex items-center justify-between"
    >
      <div className="flex items-center gap-[--spacing-sm]">
        {!isLockRoutesMode && <NeedHelpButton />}
        {selectedGanttChartTab === "Original" &&
          dataToUse &&
          !isLockVisitsMode && <LockVisitsButton />}
        {isLockVisitsMode && selectedGanttChartTab === "Original" && (
            <>
              <HoverBoxAnchor tooltipText={labels.lockVisitsInfo}>
                Lås besøg <InfoIcon width={16} height={16} />
              </HoverBoxAnchor>
              <StandardButton
                variant="PRIMARY"
                ariaLabel={labels.finalizeLockVisits}
                onClick={() => {
                  dispatch(setIsLockVisitsMode(false));
                  if (hasLockVisitsChanged) dispatch(triggerRefetch());
                }}
              >
                {labels.finalizeLockVisits}
              </StandardButton>
            </>
          )}
        {selectedGanttChartTab === "Original" &&
          dataToUse &&
          !isLockRoutesMode && (
            <StandardButton
              variant="PRIMARY"
              ariaLabel={labels.contingencyTitle}
              onClick={() => dispatch(setIsContingencyMode(true))}
            >
              {labels.contingencyTitle}
            </StandardButton>
          )}
      </div>
      <div className="flex items-center gap-[--spacing-sm]">
        <ZoomComponent />
        {dataToUse?.contingencyPlan || dataToUse?.contingencyAdjustment ? (
          <ContingencyStatusBlock
            contingencyLevel={dataToUse.contingencyAdjustment}
          />
        ) : (
          <PondooPlanStatusBar />
        )}
        {idScenario && (
          <SendToNexus
            idScenario={idScenario}
            inEditMode={selectedGanttChartTab === "Custom"}
            check={dataToUse?.enableSendPlanToNexus || false}
          />
        )}
      </div>
    </div>
  );
};

export default GanttChartConfigBar;
